import styled from "styled-components";

export default styled.main`
  max-width: 1024px;
  width: 100%;
  margin: 0 auto 32px auto;
`;
